import { DeliveryType } from 'features/checkout/delivery/deliveryType';
import { ItemDto } from 'services/Item/itemService.dto';
import { PurchaseDto } from 'services/Order/orderService.dto';
import { PaymentMethodDto } from 'services/Payment/paymentService.dto';
import { UserShippingAddressDto } from 'services/User/userService.dto';

import { CheckoutStatus } from './checkoutStatus';

export const deriveDefaultDeliveryType = (item: ItemDto): DeliveryType => {
  if (item.canLocalPickUpDelivery) {
    return 'PickUp';
  } else {
    return 'Shipment';
  }
};

export const deriveIsDeliveryTypeLocked = (item: ItemDto): boolean =>
  !item.canNationwideShipping || !item.canLocalPickUpDelivery;

interface CheckoutStatusData {
  isTokenPayment: boolean;
  isLoadingData: boolean;
  deliveryType: DeliveryType;
  paymentMethod?: PaymentMethodDto;
  shippingAddress?: UserShippingAddressDto;
  purchase?: PurchaseDto;
}

export const deriveCheckoutStatus = (data: CheckoutStatusData): CheckoutStatus => {
  const { isLoadingData, isTokenPayment } = data;
  const { deliveryType, purchase, paymentMethod, shippingAddress } = data;

  if (isLoadingData) {
    return 'NotReady';
  } else if (!paymentMethod && !isTokenPayment) {
    return 'MissingPayment';
  } else if (!shippingAddress && deliveryType === 'Shipment') {
    return 'MissingAddress';
  } else if (!purchase) {
    return 'NotReady';
  } else {
    return 'Ready';
  }
};
